<template>
  <div class="local-filders-selector">
    <AppDroppableArea class="local-filders-selector__droppable-area pa-6"
                      :disabled="disabled"
                      @ondrop="dropFilders"
    >
      <div class="d-flex flex-column align-center justify-center row-gap-6 h-100">
        <img src="/img/icons/2fichiers.svg"
             alt=""
             width="105"
        />
        <div class="text-center">
          <span class="text--small text--bold" v-t="{ path: 'common.filders.MixedFildersSelector.dragAndDropFildersHint', plural: multiple }"></span>
          <p class="text--small">
            {{ $t("common.filders.MixedFildersSelector.importAlternativeInstruction") }}
          </p>
        </div>

        <div class="d-flex flex-column align-center row-gap-2">
          <AppButton type="primary"
                      size="small"
                      :disabled="disabled"
                      @click="onFileInputClick"
          >
            <font-awesome-icon :icon="['far', 'plus']" class="mr-2" />
            <span v-t="{ path: 'common.filders.MixedFildersSelector.importFiles', plural: multiple }" />
          </AppButton>

          <AppButton v-if="!filesOnly"
                      type="primary"
                      size="small"
                      :disabled="disabled"
                      @click="onFolderInputClick"
          >
            <font-awesome-icon :icon="['far', 'plus']" class="mr-2" />
            {{ $t("common.filders.MixedFildersSelector.importFolders") }}
          </AppButton>

          <ExternalFildersSelector @select="onExternalFiles" />
        </div>
      </div>

      <input
        ref="filesLoaderInput"
        type="file"
        accept=".pdf, .doc, .docx"
        multiple
        class="d-none"
        @change="importFiles($event)"
      />
      <input
        ref="foldersLoaderInput"
        type="file"
        accept=".pdf, .doc, .docx"
        webkitdirectory
        multiple
        class="d-none"
        @change="importFiles($event)"
      />
    </AppDroppableArea>
  </div>
</template>

<script lang="ts">
import { getFilesFromDataTransferItems } from 'datatransfer-files-promise'
import { defineComponent } from 'vue'
import { mapGetters } from 'vuex'

import AppDroppableArea from '@/common/AppDroppableArea.vue'
import ExternalFildersSelector from '@/common/filders/ExternalFildersSelector.vue'
import AppButton from '@/design-system/buttons/AppButton.vue'

export default defineComponent({
  name: 'MixedFildersSelector',
  components: {
    AppButton,
    AppDroppableArea,
    ExternalFildersSelector,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    filesOnly: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('room', ['roomMnemo']),
  },
  methods: {
    async dropFilders ($event: DragEvent) {
      const dataTransferItems = $event.dataTransfer?.items
      if (dataTransferItems) {
        const droppedFiles = await getFilesFromDataTransferItems(dataTransferItems)
        this.$emit('select', droppedFiles)
      }
    },
    importFiles ($event: Event) {
      const { files } = $event.target as HTMLInputElement
      this.$emit('select', files)
      ;(this.$refs['filesLoaderInput'] as HTMLInputElement).value = ''
      ;(this.$refs['filesLoaderInput'] as HTMLInputElement).value = ''
    },
    onExternalFiles (event: { files: unknown[] }) {
      this.$emit('select', event.files)
    },
    onFileInputClick () {
      (this.$refs['filesLoaderInput'] as HTMLInputElement).click()
    },
    onFolderInputClick () {
      (this.$refs['filesLoaderInput'] as HTMLInputElement).click()
    },
  },
})
</script>

<style scoped lang="scss">
.local-filders-selector {
  border: 2px dashed #E0E0E0;
  border-radius: 7px;
  height: 100%;
  width: 100%;

  &__droppable-area {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
</style>
